/** @typedef {'ios' | 'android' | 'desktop'} StorePwaInstallHintKind */

/**
 * @param {{
 *   hintKind: StorePwaInstallHintKind,
 *   tenantName: string,
 * }} props
 */
function hintCopy({ hintKind, tenantName }) {
  if (hintKind === 'ios') {
    return {
      title: 'Adicionar à Tela de Início',
      body: (
        <>
          No iPhone, abra esta loja no <strong>Safari</strong> (se estiver no Chrome ou WhatsApp, use
          &quot;Abrir no Safari&quot;). Depois toque em <strong>Compartilhar</strong> e escolha{' '}
          <strong>Adicionar à Tela de Início</strong> para criar o ícone de {tenantName}.
        </>
      ),
    };
  }
  if (hintKind === 'android') {
    return {
      title: 'Instalar app da loja',
      body: (
        <>
          No Chrome, toque no menu <strong>⋮</strong> do navegador e escolha{' '}
          <strong>Instalar app</strong> ou <strong>Adicionar à tela inicial</strong>. O ícone de{' '}
          {tenantName} ficará na gaveta de apps do celular.
        </>
      ),
    };
  }
  return {
    title: 'Instalar atalho da loja',
    body: (
      <>
        No Chrome ou Edge, procure o ícone de instalação na barra de endereço (⊕ ou computador) ou
        use o menu do navegador em <strong>Instalar aplicativo</strong> para abrir {tenantName} como
        um app.
      </>
    ),
  };
}

/**
 * @param {{
 *   open: boolean,
 *   hintKind: StorePwaInstallHintKind,
 *   tenantName?: string,
 *   onClose: () => void,
 * }} props
 */
export function StorePwaInstallHint({ open, hintKind, tenantName = 'esta loja', onClose }) {
  if (!open) return null;

  const copy = hintCopy({ hintKind, tenantName });

  return (
    <div
      role="dialog"
      aria-labelledby="store-pwa-hint-title"
      aria-describedby="store-pwa-hint-desc"
      className="fixed inset-0 z-[210] flex items-end justify-center bg-black/45 p-4 sm:items-center"
      onClick={onClose}
    >
      <div
        className="w-full max-w-sm rounded-2xl border border-zinc-200/90 bg-white p-5 shadow-2xl dark:border-zinc-700 dark:bg-zinc-950"
        onClick={(ev) => ev.stopPropagation()}
      >
        <p id="store-pwa-hint-title" className="text-sm font-bold text-zinc-900 dark:text-zinc-50">
          {copy.title}
        </p>
        <p id="store-pwa-hint-desc" className="mt-2 text-xs leading-relaxed text-zinc-600 dark:text-zinc-400">
          {copy.body}
        </p>
        <button
          type="button"
          onClick={onClose}
          className="mt-4 w-full rounded-xl bg-[var(--st-600)] px-4 py-2.5 text-xs font-bold text-white transition hover:bg-[var(--st-700)]"
        >
          Entendi
        </button>
      </div>
    </div>
  );
}
